import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import InventoryIcon from '@mui/icons-material/Inventory';
import MedicationIcon from '@mui/icons-material/Medication';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ReceiptIcon from '@mui/icons-material/Receipt';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import SyncProblemIcon from '@mui/icons-material/SyncProblem';

const dashboard = {
    id: 'group-dashboard',
    title: 'Paineis',
    type: 'group',
    children: [
        {
            id: 'dashboard',
            title: 'Painel',
            type: 'item',
            url: '/dashboard/default',
            icon: DashboardIcon,
            breadcrumbs: false,
            filterMenu: true
        },
        {
            id: 'product-search',
            title: 'Pesquisar Produtos',
            type: 'item',
            url: '/dashboard/product-search',
            icon: MedicationIcon,
            filterMenu: true,
            breadcrumbs: true
        },
        {
            id: 'stock',
            title: 'Estoque',
            type: 'item',
            url: '/dashboard/stock',
            icon: InventoryIcon,
            breadcrumbs: true,
            filterMenu: true,
            secure: true
        },
        {
            id: 'stats',
            title: 'Estatísticas',
            type: 'collapse',
            url: '/dashboard/sales',
            icon: ReceiptIcon,
            breadcrumbs: true,
            filterMenu: true,
            // secure: true
            children: [
                {
                    id: 'sales',
                    title: 'Produtos',
                    type: 'item',
                    url: '/dashboard/sales',
                    breadcrumbs: true,
                    filterMenu: true
                }
                // {
                //     id: 'account-payable-search',
                //     title: 'Geral',
                //     type: 'item',
                //     url: '/dashboard/account-payable/search',
                //     breadcrumbs: true,
                //     filterMenu: true
                // }
            ]
        },
        {
            id: 'purchases',
            title: 'Compras',
            type: 'item',
            url: '/dashboard/purchases',
            icon: ShoppingCartIcon,
            breadcrumbs: true,
            filterMenu: true,
            secure: true,
            experimental: false,
            reloadDocument: false
        },
        {
            id: 'account-payable-group',
            title: 'Contas a Pagar',
            type: 'collapse',
            url: '/dashboard/account-payable',
            icon: AccountBalanceIcon,
            breadcrumbs: true,
            filterMenu: true,
            secure: true,
            children: [
                {
                    id: 'account-payable',
                    title: 'Por Período',
                    type: 'item',
                    url: '/dashboard/account-payable',
                    breadcrumbs: true,
                    filterMenu: true
                },
                {
                    id: 'account-payable-search',
                    title: 'Buscar Conta',
                    type: 'item',
                    url: '/dashboard/account-payable/search',
                    breadcrumbs: true,
                    filterMenu: true
                }
            ]
        },
        {
            id: 'product-transfer-group',
            title: 'Transferência de produtos',
            type: 'collapse',
            url: '/dashboard/product-transfer',
            icon: SwapHorizIcon,
            breadcrumbs: true,
            filterMenu: true,
            secure: true,
            children: [
                {
                    id: 'product-transfer',
                    title: 'Transferência de produtos',
                    type: 'item',
                    url: '/dashboard/product-transfer',
                    breadcrumbs: true,
                    filterMenu: true
                },
                {
                    id: 'product-transfer-report',
                    title: 'Acerto de transferência',
                    type: 'item',
                    url: '/dashboard/product-transfer/report',
                    breadcrumbs: true,
                    filterMenu: true
                }
            ]
        },
        {
            id: 'sync-problems',
            title: 'Sincronização',
            type: 'item',
            url: '/dashboard/sync-problems',
            icon: SyncProblemIcon,
            breadcrumbs: true,
            filterMenu: true
        }
    ]
};

export default dashboard;
